import { ApiEndpoints } from '../../../shared/webservices/endpoint';
import { PsCompanyManagement } from '../../../shared/model/PsCompanyManagement';

export class DashboardRequest {

    _companyManagement; // PsCompanyManagement

    constructor(companyManagement) {
        this._companyManagement = companyManagement;
    }

    route() {
        return this._companyManagement === PsCompanyManagement.MY_OUTSOURCES
            ? ApiEndpoints.DASHBOARD
            : ApiEndpoints.RELATED_CONTRACTORS_DASHBOARD;
    }
}



// WEBPACK FOOTER //
// ./src/app/dashboard/widgets/dashboard/DashboardRequest.js